// @mui material components
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function DataTableBodyCell({ noBorder, align, children }) {
    const isNumber = typeof children === 'string' && !isNaN(parseFloat(children.replace(/[,.]/g, '')));
    const isPrice = isNumber && (align === 'right' || children.includes('.') || children.includes(','));
    const isPercentage = typeof children === 'string' && children.includes('%');
    const hasCurrency =
        typeof children === 'string' && (children.includes('₺') || children.includes('€') || children.includes('$'));

    const renderContent = () => {
        if (isPrice && !hasCurrency) {
            return (
                <Typography
                    variant="button"
                    fontWeight="medium"
                    color={parseFloat(children) > 1000 ? 'info.main' : 'text.primary'}
                >
                    {parseFloat(children.replace(/[,.]/g, '')).toLocaleString('tr-TR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}{' '}
                    ₺
                </Typography>
            );
        } else if (isPercentage) {
            return (
                <Typography variant="button" fontWeight="medium" color="success.main">
                    {children}
                </Typography>
            );
        } else if (hasCurrency) {
            return (
                <Typography variant="button" fontWeight="medium" color="info.main">
                    {children}
                </Typography>
            );
        } else {
            return children;
        }
    };

    return (
        <TableCell
            align={align}
            sx={({ palette, typography, borders }) => ({
                fontSize: typography.size.sm,
                borderBottom: noBorder ? 'none' : `${borders.borderWidth[1]} solid ${palette.light.main}`,
                whiteSpace: 'normal',
                maxWidth: '300px',
                wordWrap: 'break-word',
                px: 3,
                py: 1.5,
            })}
        >
            <Box
                display="inline-block"
                width="max-content"
                sx={{
                    verticalAlign: 'middle',
                    maxWidth: '300px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {renderContent()}
            </Box>
        </TableCell>
    );
}

DataTableBodyCell.defaultProps = {
    noBorder: false,
    align: 'left',
};

DataTableBodyCell.propTypes = {
    children: PropTypes.node.isRequired,
    noBorder: PropTypes.bool,
    align: PropTypes.oneOf(['left', 'right', 'center']),
};

export default DataTableBodyCell;
